export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20flat%20lay%20composition%20with%20fashion%20accessories%20including%20premium%20sneakers%2C%20soft%20cashmere%20sweater%2C%20leather%20handbag%20and%20delicate%20gold%20jewelry%20arranged%20artistically%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20morning%20light%20casting%20gentle%20shadows%2C%20modern%20minimalist%20editorial%20photography%2C%20sage%20green%20and%20warm%20beige%20tones%2C%20sophisticated%20retail%20catalog%20aesthetic%2C%20clean%20airy%20composition&width=1600&height=900&seq=hero-bg-sugargoo-v2&orientation=landscape"
        alt="Sugargoo Spreadsheet lifestyle product photography"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          Sugargoo Spreadsheet
          <br />
          <span className="text-accent-400">The Ultimate Resource</span> For Smart Shopping
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Find updated Sugargoo Spreadsheet collections, organized product categories, shopping guides, shipping information, and expert resources — all in one place.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-background-50/15 hover:bg-background-50/25 text-white border border-white/30 px-8 py-3.5 rounded-md text-base font-semibold transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Buy It Now
          </a>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {['Updated Spreadsheet Resources', 'Complete Shopping Guides', 'Shipping Information', 'Beginner Friendly'].map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-xs md:text-sm text-white/70">
              <i className="ri-check-line text-accent-400"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}